import { useNavigate } from 'react-router-dom';
import { ProviderHeader } from './components/ProviderHeader';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

const ProviderPortal = () => {
  const navigate = useNavigate();

  const handleNavigation = (path: string) => {
    console.log('Navigating to:', path);
    try {
      const normalizedPath = path.startsWith('/') ? path : `/${path}`;
      navigate(normalizedPath);
    } catch (error) {
      console.error('Navigation error:', error);
    }
  };

  return (
    <div className="container mx-auto px-4 sm:px-6 py-6 space-y-6">
      <ProviderHeader 
        onAssessmentClick={() => handleNavigation('/provider/assessment')}
        onCarePlanningClick={() => handleNavigation('/provider/care-planning')}
        onProgressClick={() => handleNavigation('/provider/progress')}
      />
      
      <Card>
        <CardHeader>
          <CardTitle>Provider Dashboard</CardTitle>
        </CardHeader>
        <CardContent>
          <p className="text-muted-foreground">Provider dashboard functionality coming soon.</p>
        </CardContent>
      </Card>
    </div>
  );
};

export default ProviderPortal;